import type { SubscriptionCheckoutStatus } from '@/shared/api';

export const PAID_WITHOUT_SUBSCRIPTION_GRACE_MS = 120_000;

export type CheckoutStatusProbe =
  | { kind: 'status'; status: SubscriptionCheckoutStatus }
  | { kind: 'missing' }
  | { kind: 'unavailable' };

export interface CheckoutReconciliationContext {
  now: number;
  paidObservedAt: number | null;
}

export type CheckoutReconciliationAction =
  { type: 'reset' } | { type: 'wait' } | { type: 'needsSupport' } | { type: 'noop' };

export const reconcileCheckout = (
  probe: CheckoutStatusProbe,
  context: CheckoutReconciliationContext
): CheckoutReconciliationAction => {
  if (probe.kind === 'missing') return { type: 'reset' };
  if (probe.kind === 'unavailable') return { type: 'noop' };
  if (probe.status === 'Expired') return { type: 'reset' };

  if (probe.status === 'Paid') {
    return context.paidObservedAt !== null &&
      context.now - context.paidObservedAt > PAID_WITHOUT_SUBSCRIPTION_GRACE_MS
      ? { type: 'needsSupport' }
      : { type: 'wait' };
  }

  return { type: 'wait' };
};
